import { render, staticRenderFns } from "./MovePanel.vue?vue&type=template&id=31f37561&scoped=true"
import script from "./MovePanel.vue?vue&type=script&lang=js"
export * from "./MovePanel.vue?vue&type=script&lang=js"
import style0 from "./MovePanel.vue?vue&type=style&index=0&id=31f37561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f37561",
  null
  
)

export default component.exports